import { FC } from 'react';

import {
  ContentHeader,
  LayoutWithNavigationBreadcrumbs,
  NavigationBreadcrumbsTitles,
} from 'components';
import { FormSubmit } from 'libs/form';
import { useTranslation } from 'libs/i18n';
import { Stack } from 'libs/ui';
import {
  OperationFormContent,
  OperationFormContentProps,
} from 'modules/operation/common/components';

import {
  Form,
  getSchema,
  OperationFormType,
} from '../../common/forms/operationForm';
import { OperationFormFooter } from '../components';

export interface CreateOperationViewProps
  extends Omit<OperationFormContentProps, 'mode'> {
  initialValues?: Partial<OperationFormType>;
  breadcrumbsTitles?: NavigationBreadcrumbsTitles;
  submitLoading?: boolean;
  onBack: () => void;
  onSubmit: FormSubmit<OperationFormType>;
}

export const CreateOperationView: FC<CreateOperationViewProps> = ({
  initialValues,
  breadcrumbsTitles,
  submitLoading,
  onBack,
  onSubmit,
  ...formContentProps
}) => {
  const { t } = useTranslation();
  const validationSchema = getSchema(t);

  return (
    <LayoutWithNavigationBreadcrumbs titles={breadcrumbsTitles}>
      <Form
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        <Stack spacing={24}>
          <ContentHeader header={t('operation.createOperation.title')} />
          <OperationFormContent {...formContentProps} mode="create" />
          <OperationFormFooter submitLoading={submitLoading} onBack={onBack} />
        </Stack>
      </Form>
    </LayoutWithNavigationBreadcrumbs>
  );
};
